import "./Profile.css";
import waitingScreen from "../waitingScreen/waitingScreen";

import { useEffect, useState } from "react";
import monster from "../../img/monster.jpg";
import King from "../../img/King.png";
import pawn from "../../img/pawn.png";
import Rook from "../../img/Rook.png";
import Rank from "../Rank/Rank";
import { useSocket } from "../../context/socketContext";
// import ClockTimer from "../ClockTimer/ClockTimer";

function Profile() {
  const { socket, globalUserName, opponentUserName, setOpponentUserName, globalWin, setGlobalWin, globalLose, setGlobalLose, globalRank, setGlobalRank, validToGo, setValidToGo } = useSocket();
  const [profileRoute, setProfileRoute] = useState("Profile");
  const [XOList, setXOList] = useState([])
  function expandOnClick() {
    document.getElementById("rankPage").style.animation = "expand 5s ease-in-out forwards";
    document.getElementById("rankPage").style.position = "absolute";
    document.getElementById("winRate").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("onlineStreak").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("playerCardWrapper").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("findMatch").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("onOffSymbol").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("closingX").style.animation = "gonein 5s ease-in-out forwards";
    document.getElementById("closingX").style.marginTop = "-10vh";
    document.getElementById("closingX").style.marginLeft = "95vw";
    document.getElementById("Rank").style.animation = "gonein 5s ease-in-out forwards";
    document.getElementById("onOffRank").style.animation = "gonein 5s ease-in-out forwards";
    // document.getElementById('yourRank').style.animation='diagonal-move 5s ease-in-out';
    document.getElementById("rankPage").style.border = "none";
  }
  function collapseOnClick() {
    document.getElementById("rankPage").style.animation = "collapse 5s ease-in-out forwards";
    document.getElementById("rankPage").style.animation = "floating 3s ease-in-out infinite";
    document.getElementById("rankPage").style.position = "relative";
    document.getElementById("winRate").style.animation = "gonein 5s ease-in-out forwards";
    document.getElementById("closingX").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("onlineStreak").style.animation = " gonein 5s ease-in-out forwards";
    document.getElementById("playerCardWrapper").style.animation = "gonein 5s ease-in-out forwards";
    document.getElementById("findMatch").style.animation = "gonein 5s ease-in-out forwards";
    document.getElementById("onOffSymbol").style.animation = "gonein 5s ease-in-out forwards";
    document.getElementById("winRate").style.animation = "floating 3s ease-in-out infinite";
    document.getElementById("onlineStreak").style.animation = "floating 3s ease-in-out infinite";
    document.getElementById("Rank").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("rankPage").style.border = " 5px solid #62676a";
    document.getElementById("rankPage").style.borderRadius = " 5%";
  }

  // Grid mapping used to store placement of X's and O's
  useEffect(() => {
    let temp = []
    for (let i = 0; i < 25; i++) { temp.push(new Array(25)); }
    setXOList([...temp])
  }, [])


  function checkWin(currentTarget) {

    let row = Math.floor(parseInt(currentTarget.id) / 100);
    let column = Math.floor(parseInt(currentTarget.id) % 100);

    socket.emit('xo_click', {
      username: globalUserName,
      opponent_username: opponentUserName,
      row, column
    })

    let N = 5; // amount of connection required to win
    let numberHorizontal = 1
    let numberVertical = 1
    let numberLeftDiagonal = 1
    let numberRightDiagonal = 1
    let currentSelection = getSquareContent(row, column);
    let isWin = false;

    // horizontal
    for (let i = row - 1; i >= 0; i--) { if (getSquareContent(i, column) === currentSelection) numberHorizontal += 1; else break; }
    for (let i = row + 1; i < 25; i++) { if (getSquareContent(i, column) === currentSelection) numberHorizontal += 1; else break; }
    // vertical
    for (let j = column - 1; j >= 0; j--) { if (getSquareContent(row, j) === currentSelection) numberVertical += 1; else break; }
    for (let j = column + 1; j < 25; j++) { if (getSquareContent(row, j) === currentSelection) numberVertical += 1; else break; }
    // left diagonal
    for (let i = row - 1, j = column - 1; i >= 0 && j >= 0; i-- && j--) { if (getSquareContent(i, j) === currentSelection) numberLeftDiagonal += 1; else break; }
    for (let i = row + 1, j = column + 1; i < 25 && j < 25; i++ && j++) { if (getSquareContent(i, j) === currentSelection) numberLeftDiagonal += 1; else break; }
    // right diagonal
    for (let i = row - 1, j = column + 1; i >= 0 && j < 25; i-- && j++) { if (getSquareContent(i, j) === currentSelection) numberRightDiagonal += 1; else break; }
    for (let i = row + 1, j = column - 1; i < 25 && j >= 0; i++ && j--) { if (getSquareContent(i, j) === currentSelection) numberRightDiagonal += 1; else break; }

    if (numberHorizontal >= N || numberVertical >= N || numberLeftDiagonal >= N || numberRightDiagonal >= N) {



      isWin = true;
      console.log(currentSelection, " win!")
      setProfileRoute('Profile')




    }
  }

  function getSquareContent(row, col) {
    let square = document.getElementById((row * 100 + col).toString())
    return square.innerText;
  }

  var firstPlayerContest = 1;
  var secondPlayerContest = 1;
  let contest = false;

  function contestClick() {
    if (firstPlayerContest === 1 || secondPlayerContest === 1) {
      contest = true;
    }
    console.log(contest);
  }

  function playOnClick(e) {
    if (!validToGo) { return }
    let target_id = e.currentTarget.id;

    document.getElementById(target_id).innerText = 'X'
    let row = Math.floor(parseInt(target_id) / 100);
    let column = Math.floor(parseInt(target_id) % 100);

    checkWin(e.currentTarget);
    setValidToGo(false)
  }
  const XOboard = [];

  for (let i = 0; i < 25; i++) {
    for (let j = 0; j < 25; j++) {
      XOboard.push(
        <div
          id={`${j * 100 + i}`}
          onClick={playOnClick}
          className={"square"}
        ></div>
      );
    }
  }
  function slideOnClick() {
    document.getElementById("rankPage").style.animation = "slideOut 5s ease-in-out forwards";
    document.getElementById("winRate").style.animation = "slideOut 5s ease-in-out forwards";
    document.getElementById("onlineStreak").style.animation = "slideOut 5s ease-in-out forwards";
    document.getElementById("playerCardWrapper").style.animation = "goneout 5s ease-in-out forwards";
    document.getElementById("findMatch").style.animation = "goneout 5s ease-in-out forwards";
    setProfileRoute("waitingScreen");
    socket.emit("find_match", globalUserName, (res) => {
      console.log(res);
    });
  }

  useEffect(() => {
    socket.on("match_found", (opponentName) => {
      console.log('opponentName', opponentName)
      setOpponentUserName(opponentName);
      setProfileRoute("Match");
    });

    socket.on("opponent_xo_click", (data) => {
      let { username, row, col } = data;
      console.log(data);
      let element = document.getElementById((row * 100 + col).toString())
      element.innerText = 'O';
      checkWin(element)
      setValidToGo(true)
    })
  }, [socket])
  useEffect(() => {
    fetch('https://nestjs-socket-server-production.up.railway.app/users/info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: globalUserName,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setGlobalLose(data.lose);
        setGlobalWin(data.win);
        setGlobalRank(data.elo);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, [])
  return (
    <div id="Profile">
      <div className="logoBar">The Crox</div>
      {profileRoute === "Profile" ?
        <>
          <div className="profileInfo">
            <div className="onlineStreak" id="onlineStreak">
              <h1> Win</h1>
              <div className="symbolWrapper2">
                <div className="symbol1">
                  <a>{globalWin}</a>
                  <img src={pawn} alt="pawn"></img>
                </div>
              </div>
            </div>
            <div className="rankBoard" id="rankPage">
              <div id="rankNav">
                <h1 id="yourRank">Rank</h1>
                <h1 id="closingX" onClick={collapseOnClick}>
                  X
                </h1>
              </div>

              <Rank id="onOffRank" />
              <div className="symbolWrapper2">
                <div className="symbol2" id="onOffSymbol" onClick={expandOnClick}>
                  <a>{globalRank}</a>
                  <img src={King} alt="King"></img>
                </div>
              </div>
            </div>
            <div className="winRate" id="winRate">
              <h1>Lose </h1>
              <div className="symbolWrapper2">
                <div className="symbol3">
                  <a>{globalLose}</a>
                  <img src={Rook} alt="Rook"></img>
                </div>
              </div>
            </div>
          </div>
          <div className="playerCardWrapper" id="playerCardWrapper">
           
            <div className="playerCard">
              <h4>{globalUserName}</h4>
            </div>
          </div>
          <div className="findMatch" id="findMatch">
            <button onClick={slideOnClick}> Find Match!</button>
          </div></> : profileRoute === "Match" ? (
        <div className="MatchContainer">
          <div className="playerCardWrapper" id="contest">
            <button onClick={contestClick}>Contest</button>
          </div>
          <>
            <div className="playerCardWrapper" id="allies">
              <div className="playerCard">
                <h4>{globalUserName}</h4>
              </div>
            </div>
            <div className="Match">{XOboard}</div>

            <div className="playerCardWrapper" id="oponent">
              <div className="playerCard">
                <h4>{opponentUserName}</h4>
              </div>
            </div>
          </>
        </div>
      ) : (
        <div className="waitingScreen" id="waitingScreen">
          <h1>Waiting.....</h1>
        </div>
      )}
    </div>
  );
}

export default Profile;
